<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["labels", "data", "errorData", "render"],

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: "Api Calls",
              backgroundColor: this.$primaryColor,
              data: this.data,

              borderColor: "#502F8C",
              maxBarThickness: 50,
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
            },
            {
              label: "Errors",
              backgroundColor: "#ef4444",
              maxBarThickness: 50,
              data: this.errorData,
              fill: false,
              borderColor: "#ef44448c",
              pointBackgroundColor: "#ef4444",
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        }
      );
    },
  }
};
</script>

 